module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "title-part"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466817081_toc01#toctitle9",
      "id": "title9"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART II")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Self-portrait, study for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The Artist and His Mother")]), _vm._v(", c. 1936")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781466817081_i0004.jpg",
      "src": "e9781466817081_i0004.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-065f363c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466817081_p02.vue
// module id = 93
// module chunks = 0